import { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { getUserNotifications as requestGetUserNotifications } from "@utils/aegean_api_handler";
import { EVENT_TYPE, handleError } from "@utils/helpers";
import { notify } from "@utils/notifications";

const getUserNotifications = currentUserId => () => requestGetUserNotifications(currentUserId);

export class NotificationHandler extends Component {
  static propTypes = {
    currentUser: PropTypes.shape({
      id: PropTypes.number.isRequired
    }).isRequired,
    getUserNotifications: PropTypes.func.isRequired
  };

  componentDidMount() {
    if (process.env.ATLANTIC_DOMAIN && process.env.ATLANTIC_DOMAIN.includes("local")) {
      // don't fetch notifications locally
    } else {
      this.getNotifications();
      this.interval = setInterval(this.getNotifications, 60000);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  getNotifications = async () => {
    const { currentUser, getUserNotifications } = this.props;

    try {
      const notifications = await getUserNotifications(currentUser.id);

      if (notifications) {
        notifications.forEach(notificaiton => notify(notificaiton.message));
      }
    } catch (error) {
      handleError(
        "Failed getting notifications",
        error,
        EVENT_TYPE.ERROR.POLLING_NOTIFICATION
      );
    }
  };

  render() {
    return null;
  }
}

export default connect(
  store => ({
    currentUser: store.session.data && store.session.data.user
  }),
  {
    getUserNotifications // Not a Redux action, but we need it connected for testing purposes
  }
)(NotificationHandler);
